import { Tag } from 'bold-ui'
import React from 'react'

interface CidadaoStatusGruposProps {
  faleceu: boolean
  unificado: boolean
}

export const CidadaoStatusGrupos = ({ faleceu, unificado }: Readonly<CidadaoStatusGruposProps>) => {
  if (faleceu) return <Tag>Óbito</Tag>
  if (unificado) return <Tag>Cadastro unificado</Tag>

  return null
}
